import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Tooltip from '@mui/material/Tooltip';

const downloadFile = async (url) => {
    try {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        const fileName = url.split('/').pop(); // Extract file name from URL
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    } catch (error) {
        console.error('Error downloading file:', error);
    }
};

export const RenderDocumentColumn = (value) => {
                                                   if (
                                                       !value ||
                                                       value.length <= 2
                                                   )
                                                       return null;

                                                   const fileExtension = value
                                                       .split('.')
                                                       .pop()
                                                       .toLowerCase();
                                                   const isImage = [
                                                       'png',
                                                       'jpg',
                                                       'jpeg',
                                                       'gif',
                                                       'bmp',
                                                       'webp'
                                                   ].includes(fileExtension);
                                                   const isPDF =
                                                       fileExtension === 'pdf';

                                                   if (isImage) {
                                                       return (
                                                           <Tooltip
                                                               title="Click to open image"
                                                               arrow
                                                           >
                                                               <img
                                                                   src={value}
                                                                   className="gridImg"
                                                                   alt="document"
                                                                   height={40}
                                                                   width={40}
                                                                   style={{
                                                                       cursor:
                                                                           'pointer',
                                                                       border:
                                                                           '1px solid #ddd',
                                                                       borderRadius:
                                                                           '4px',
                                                                       padding:
                                                                           '2px'
                                                                   }}
                                                                   onClick={() =>
                                                                       window.open(
                                                                           value,
                                                                           '_blank'
                                                                       )
                                                                   }
                                                               />
                                                           </Tooltip>
                                                       );
                                                   }
                                                   if (isPDF) {
                                                       return (
                                                           <Tooltip
                                                               title="Download PDF"
                                                               arrow
                                                           >
                                                               <div
                                                                   onClick={() =>
                                                                       downloadFile(
                                                                           value
                                                                       )
                                                                   }
                                                                   style={{
                                                                       cursor:
                                                                           'pointer',
                                                                       padding:
                                                                           '8px',
                                                                       display:
                                                                           'flex',
                                                                       alignItems:
                                                                           'center'
                                                                   }}
                                                               >
                                                                   <CloudDownloadIcon
                                                                       color="primary"
                                                                       style={{
                                                                           marginRight:
                                                                               '4px'
                                                                       }}
                                                                   />
                                                                   <span
                                                                       style={{
                                                                           fontSize:
                                                                               '12px'
                                                                       }}
                                                                   >
                                                                       PDF
                                                                   </span>
                                                               </div>
                                                           </Tooltip>
                                                       );
                                                   }

                                                   return (
                                                       <Tooltip
                                                           title={`Download ${fileExtension.toUpperCase()} file`}
                                                           arrow
                                                       >
                                                           <div
                                                               onClick={() =>
                                                                   downloadFile(
                                                                       value
                                                                   )
                                                               }
                                                               style={{
                                                                   cursor:
                                                                       'pointer'
                                                               }}
                                                           >
                                                               <CloudDownloadIcon color="primary" />
                                                           </div>
                                                       </Tooltip>
                                                   );
                                               };
